import React, { useEffect, useState } from "react";
import ETipsBanner from "./view/_tips-banner";
import { useSelector } from "react-redux";
import { tipService } from "./service/tips_service";
import moment from "moment";
import { store } from "../../../helpers/store";
import { adminService } from "../../../services/admin.service";
import { commonService } from "../../../services/common.service";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {Skeleton} from '@material-ui/lab'
const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
    height: "100%",
  },
  content: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  image: {
    height: "47%",
    marginBottom: "5px",
  },
  heading: {
    textTransform: "Uppercase",
    color: theme.palette.ePrimary?.base,
    marginBottom: "5px",
  },
}));

export default function E_Tips() {
  const styles = useStyles();
  const [data, setData] = useState([]);
  const [NoTipsImage, setNoTipsImage] = useState("");
  let noTipsimage = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_NO_TIPS_IMAGE
  );
  const customerClass =useSelector(
    (store) => store?.meterDetails?.customerClassCd
  );
  let tipLabels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_ENERGY_SAVING_TIPS
  );
  

  let languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );

  useEffect(() => {
    if (noTipsimage) {
      commonService.getAssestUrl(noTipsimage)
      .then((response) => {
        setNoTipsImage(response);
      })
      .catch((error)=>{
        setNoTipsImage("");
      });
    }
  }, [noTipsimage]);


  useEffect(() => {
    if (customerClass && languageCode) {
      tipService
        .getTips(customerClass,languageCode)
        .then((res) => {
          setData(res?.data?.getTips?.tipsDetails);
        })
        .catch((error) => {
          setData([]);
        });
    }
  }, [customerClass,languageCode]);

  // const [content, setContent] = useState(null);
  const {t:content, ready: contentReady} = useTranslation("content-E_ENERGY_SAVING_TIPS")
  const {t:labels,ready:labelsReady}=useTranslation("label-E_ENERGY_SAVING_TIPS")
  return (
    <>
      {(data.length) ? (
        <ETipsBanner data={data} />
      ) : (
        <Card className={styles.card}>
          <Typography variant="h6" className={styles.heading}>
          {labelsReady?labels("E_TIPS_HEADING"):""}
          </Typography>
          <div className={styles.content}>
            {NoTipsImage && (
              <img
                className={styles.image}
                src={NoTipsImage?.assetPath}
               // alt={tipLabels?.[noTipsimage?.fallBackLabelKey]}
              />
            )}
            {
            contentReady ?
            <Typography variant="body2">{content("E_NO_ENERGY_SAVING_TIPS").answer}</Typography> :
            <Skeleton />
            }
          </div>
        </Card>
      )}
    </>
  );
}
